import DefAvatar from "@3gaam/shared/assets/images/def-avatar.svg";
import Icon from "@3gaam/shared/components/general/icon";
import Image from "@3gaam/shared/components/general/optimizedImage";
import { useCallback, useState } from "react";
import { VideoModal } from "../../pcapp/components/VideoModal";

export const Avatar = ({
  src,
  alt,
  size = 56,
  borderRadius = 56,
  videoUrl,
  noBorder,
  borderWidth = 2,
}: {
  src?: string | null | undefined;
  alt?: string | undefined | null;
  size: number;
  borderRadius?: number;
  videoUrl?: string | null;
  noBorder?: boolean;
  borderWidth?: number;
}) => {
  let [showVideoModalState, setShowVideoModal] = useState(false);
  const showVideoModal = useCallback(() => {
    if (!videoUrl) return;
    setShowVideoModal(true);
  }, [videoUrl]);

  return (
    <>
      <div
        className={`d-flex position-relative flex-shrink-0 user-select-none ${
          noBorder ? "" : "counselor-avatar"
        }`}
        style={{
          height: noBorder ? size : size + borderWidth * 2,
          width: noBorder ? size : size + borderWidth * 2,
          borderRadius,
          flexShrink: 0,
          borderWidth,
        }}
      >
        <Image
          src={src || DefAvatar}
          alt={alt || undefined}
          style={{
            height: size,
            width: size,
            borderRadius,
            flexShrink: 0,
            objectFit: "cover",
          }}
          width={size}
          height={size}
        />
        {!!videoUrl && (
          <div
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              showVideoModal();
            }}
            className={`video-icon-button cur-pointer`}
          >
            <div className="wrapper">
              <Icon name="FA_S-caret-down" className="text-white" />
            </div>
          </div>
        )}
      </div>
      {!!videoUrl && (
        <VideoModal
          showState={showVideoModalState}
          setShowState={() => {
            setShowVideoModal(false);
          }}
          videoSource={videoUrl}
        />
      )}
    </>
  );
};
